import { render, staticRenderFns } from "./PathwayDetail.vue?vue&type=template&id=2fe24396&scoped=true"
import script from "./PathwayDetail.vue?vue&type=script&lang=js"
export * from "./PathwayDetail.vue?vue&type=script&lang=js"
import style0 from "./PathwayDetail.vue?vue&type=style&index=0&id=2fe24396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe24396",
  null
  
)

export default component.exports